// quote-card 动画：已揭示字符数。
import type { SceneData } from '../../api/types'
import type { QuoteData } from './types'

export function quoteRevealed(d: SceneData, time: number, duration: number): number {
  const data = d as unknown as QuoteData
  const totalChars = data.quote?.length ?? 0
  if (totalChars === 0) return 0
  const denom = duration - 2 > 0 ? duration - 2 : 1
  const revealRate = totalChars / denom
  const revealed = Math.floor(time * revealRate)
  return Math.min(Math.max(revealed, 0), totalChars)
}
